import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  MENU_PUSH_FORM_TEXT,
  MENU_PUSH_FORM_URL,
  MENU_PUSH_LOG_TEXT,
  MENU_PUSH_SEND_TEXT,
  MENU_FILE_LIST_TEXT,
} from '../../util/Const';
import { context } from '../../App';
import { Logout } from '../../handler/LoginHandler';

const Popup = (props: any) => {
  const { dispatch } = useContext(context);
  const { history, setDisplayPopup } = props;

  const handlePopupClick = (e: any) => {
    if (e.target.closest('#logout_popup')) {
      Logout(dispatch, history);
    } else {
      setDisplayPopup(false);
      document.removeEventListener('click', handlePopupClick);
    }
  };

  document.addEventListener('click', handlePopupClick);

  return (
    <section id="logout_popup">
      <button type="button" className="btn_logout">
        ログアウト
      </button>
    </section>
  );
};

const Menu = (props: any) => {
  const { history } = props;
  const [displayPopup, setDisplayPopup] = useState<boolean>(false);

  const handleNavClick = (e: any) => {
    e.stopPropagation();
    setDisplayPopup(!displayPopup);
  };

  return (
    <section id="left_side">
      <h2>管理画面メニュー</h2>
      <div
        className={
          history.location.pathname === '/PushSend' ? 'menu on' : 'menu'
        }
      >
        <Link to="/PushSend">{MENU_PUSH_SEND_TEXT}</Link>
      </div>
      <div
        className={
          history.location.pathname === '/PushLog' ? 'menu on' : 'menu'
        }
      >
        <Link to="/PushLog">{MENU_PUSH_LOG_TEXT}</Link>
      </div>
      {sessionStorage.getItem('city') === '0' &&
      sessionStorage.getItem('village') === '2' ? null : (
        <div
          className={
            history.location.pathname === '/FileList' ? 'menu on' : 'menu'
          }
        >
          <Link to="/FileList">{MENU_FILE_LIST_TEXT}</Link>
        </div>
      )}
      <div className="menu">
        <a target="_blank" href={MENU_PUSH_FORM_URL} rel="noreferrer">
          {MENU_PUSH_FORM_TEXT}
        </a>
      </div>
      <div id="logout_btn">
        <button
          type="button"
          className="btn"
          onClick={(e) => handleNavClick(e)}
        >
          ログアウト
        </button>
        {displayPopup ? (
          <Popup history={history} setDisplayPopup={setDisplayPopup} />
        ) : null}
      </div>
    </section>
  );
};
export default Menu;
